import {PlanOption} from './upgrade-plan.types'

/**
 * Rollback do Plano Pro legado no modal de upgrade:
 * altere INCLUDE_LEGACY_PLANO_PRO para `false`.
 */
export const UPGRADE_PLAN_CONFIG = {
  INCLUDE_LEGACY_PLANO_PRO: true,
  /** Quantidade padrão de usuários avulsos a adicionar ao plano. */
  DEFAULT_ADDITIONAL_USERS: 1,
  MIN_ADDITIONAL_USERS: 1,
  /** @deprecated use DEFAULT_ADDITIONAL_USERS */
  DEFAULT_USERS_NUMBER: 1,
  /** @deprecated use MIN_ADDITIONAL_USERS */
  MIN_USERS_NUMBER: 1,
} as const

export const LEGACY_UPGRADE_PLAN_OPTIONS: PlanOption[] = [
  {
    key: 'PLANO_PRO',
    title: 'Plano Pro',
    backendName: 'Plano Pro',
    subTitle: 'Plano para assinantes com contrato vigente.',
    description: 'Plano legado com recursos avançados para colaboração e produtividade.',
    custom: false,
    minUsers: UPGRADE_PLAN_CONFIG.MIN_USERS_NUMBER,
    maxUsers: 100,
    features: [
      {title: 'Projetos e tarefas ilimitadas', supported: true},
      {title: 'Gestão de clientes', supported: true},
      {title: 'Time tracking completo', supported: true},
      {title: 'Relatórios de rentabilidade ✦', supported: true},
      {title: 'Gestão de contratos', supported: true},
      {title: 'Portal do cliente', supported: true},
      {title: 'RushMind IA ✦', supported: true},
      {title: 'Sprints, Kanban e Gantt', supported: true},
      {title: 'Wiki', supported: true},
      {title: 'Suporte WhatsApp e email', supported: true},
    ],
  },
]

export const LEGACY_PLAN_BACKEND_NAMES = LEGACY_UPGRADE_PLAN_OPTIONS.map(
  (plan) => plan.backendName
)
